<template>
    <div class="row">
        <div class="col-12 mb-1">
            <label class="form-label">Kullanım Amacı</label>
            <v-validator :errors="errors" parameter="SystemMailKeyId" :watch="key">
                <v-select-list v-model="key" label="Name" placeholder="Kullanım Amacı" :options="systemMailKeys"/>
            </v-validator>   
        </div>
        <div class="col-6 mb-1">
            <label class="form-label">Mail Adı</label>
            <v-validator :errors="errors" parameter="value.MailName" :watch="MailName">
                  <input type="text" class="form-control" placeholder="Mail Adı" v-model="value.MailName"/>
            </v-validator>
        </div>
        <div class="col-6 mb-1">
            <label class="form-label">Mail Adresi</label>
            <v-validator :errors="errors" parameter="value.MailAddress" :watch="MailAddress">
                <input type="text" class="form-control" placeholder="Mail Adresi" v-model="value.MailAddress"/>
            </v-validator>   
        </div>
        <div class="col-6 mb-1">
            <label class="form-label">Parola</label>
            <v-validator :errors="errors" parameter="value.Password" :watch="Password">
                <input type="text" class="form-control" placeholder="Parola" v-model="value.Password"/>
            </v-validator>
        </div>
        <div class="col-6 mb-1">
            <label class="form-label">Sunucu/Host</label>
            <v-validator :errors="errors" parameter="value.Host" :watch="Host">
                 <input type="text" class="form-control" placeholder="Sunucu/Host" v-model="value.Host"/>
            </v-validator>
        </div>
        <div class="col-6 mb-1">
            <label class="form-label">Port</label>
            <v-validator :errors="errors" parameter="value.Port" :watch="Port">
                 <input type="text" class="form-control" placeholder="Port" v-model="value.Port"/>
            </v-validator>
        </div>
        <div class="col-6 mb-1">
            <label class="form-label">Domain (Alan Adı - Zorunlu Değil)</label>
            <v-validator :errors="errors" parameter="value.Domain" :watch="Domain">
                 <input type="text" class="form-control" placeholder="Domain" v-model="value.Domain"/>
            </v-validator>
        </div>
        <div class="col-6 mb-1">
            <b-form-checkbox v-model="value.EnableSSL" name="ssl-cb">SSL</b-form-checkbox>
        </div>
        
        
    </div>
</template>

<script>
import { BFormCheckbox } from 'bootstrap-vue'
import SystemDataApi from '@/api/system-data'
export default {
    components:{
        BFormCheckbox
    },
    props:{
        value:Object,
        errors:Object
    },
    data(){
        return{
            systemMailKeys:[],
        }
    },
    mounted(){
        this.getSystemMailKeys();
    },
    methods:{
        getSystemMailKeys(){
            SystemDataApi.SystemMailKey()
            .then(res=>{
                this.systemMailKeys = res.data.Data
            })
        },
    },
    computed:{
        key:{
            get:function(){
                return this.systemMailKeys.find(b=>b.Id==this.value.SystemMailKeyId)
            },
            set:function(value){
                this.value.SystemMailKeyId = value?.Id || this.value.SystemMailKeyId
            }
        }
    }

}
</script>

<style lang="scss">
</style>